import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import { CreateEventFormData, CreateEventFormErrors } from '@/types/admin/createEvent';
import { GlassFormInput } from '@/components/admin/redesign';
import { SectionHeader } from '@/components/shared/redesign';

interface EventSettingsSectionProps {
  formData: CreateEventFormData;
  errors: CreateEventFormErrors;
  onFieldChange: (field: keyof CreateEventFormData, value: string | Date) => void;
}

export const EventSettingsSection = memo<EventSettingsSectionProps>(
  ({ formData, errors, onFieldChange }) => {
    return (
      <View style={styles.section}>
        <SectionHeader title="Settings" />

        {/* RSVP Limit */}
        <GlassFormInput
          label="Max Attendees"
          placeholder="0 for unlimited"
          value={formData.rsvpLimit}
          onChangeText={(text) => onFieldChange('rsvpLimit', text)}
          keyboardType="numeric"
          error={errors.rsvpLimit}
        />

        {/* Internal Notes */}
        <GlassFormInput
          label="Internal Notes"
          placeholder="Internal Notes"
          value={formData.internalNotes}
          onChangeText={(text) => onFieldChange('internalNotes', text)}
          multiline
          numberOfLines={3}
          textAlignVertical="top"
        />
      </View>
    );
  },
);

EventSettingsSection.displayName = 'EventSettingsSection';

const styles = StyleSheet.create({
  section: {
    marginBottom: 24,
  },
});
